<progress
  class="bar"
  [attr.aria-label]="ariaLabel()"
  [attr.data-status]="status()"
  [value]="track().value"
  [max]="track().max"
></progress>
@if (hasLabels()) {
  <div class="labels">
    <span>{{ startLabel() }}</span>
    <span>{{ endLabel() }}</span>
  </div>
}
